import React, { useMemo, useState } from 'react'
import { FaThumbsUp, FaComment, FaEllipsisV, FaRegThumbsUp, FaSave, FaTrash, FaFlag, FaPen, FaShare, FaTimes, FaMinusCircle, FaEnvelope, FaMarker, FaEllipsisH } from 'react-icons/fa'
import officeImg from "../assets/office.png"
import UserImage from "../assets/user.png"
import moment from 'moment'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import Linkify from 'linkify-react'

const OrgPostCard = ({ orgPost }) => {
    const [profileInfo, setProfileInfo] = useState(false)
    const [postInfo, setPostInfo] = useState(false)
    const [liked, setLiked] = useState(false)
    const [likesCount, setLikesCount] = useState(orgPost.likesCount)
    const [loadDelete, setloadDelete] = useState(false)

    // console.log(orgPost)


    const userId = useSelector((state) => state.auth?.user?.user?._id)

    const { organization } = useParams()
    const navigate = useNavigate()

    const imageFiles = useMemo(
        () => orgPost?.files?.filter(f => f.type === "image") || [],
        [orgPost]
    );
    const [focusedImg, setFocusedImg] = useState(imageFiles[0]?.url || null);

    const linkifyOptions = {
        target: "_blank",
        rel: "noopener noreferrer",
        className: "post-link"
    };

    const likePost = async (postId) => {
        const previousLiked = liked;

        // Optimistic update
        setLiked(!previousLiked);
        setLikesCount((prev) => prev + (previousLiked ? -1 : 1));

        try {
            const response = await api.patch(
                `/${organization}/posts/${postId}/likes`
            );

            const serverLiked = response?.data?.liked;

            // Sync with server truth
            if (serverLiked !== !previousLiked) {
                setLiked(serverLiked);
                setLikesCount((prev) => prev + (serverLiked ? 1 : -1));
            }

        } catch (error) {
            // Revert on failure
            setLiked(previousLiked);
            setLikesCount((prev) => prev + (previousLiked ? 1 : -1));

            toast.error("Failed to update like.");
        }
    };

    const tooglePostInfo = () => {
        setProfileInfo(false)
        setPostInfo(!postInfo)
    }
    const toogleProfileInfo = () => {
        setProfileInfo(!profileInfo)
        setPostInfo(false)
    }

    const renderImages = () => (
        <>
            <div className="focused-image">
                <img src={focusedImg} alt="onnize" />
            </div>

            {imageFiles.length > 1 && (
                <div className="image-selector">
                    {imageFiles.map((file, i) => (
                        <div
                            key={i}
                            className="image-selector-wrapper"
                            onClick={() => setFocusedImg(file.url)}
                        >
                            <img src={file.url} alt={file.name} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );

    const renderVideo = (file) => (
        <div className="video-container">
            <video controls>
                <source src={file.url} type={file.mimeType} />
            </video>
        </div>
    );

    const renderDocuments = () => (
        <div className="document-container">
            {orgPost.files.map((file, i) => {
                const ext = file.name.split(".").pop().toLowerCase();

                if (ext === "pdf") {
                    return (
                        <div key={i} className="document-preview">
                            <iframe src={file.url} title={file.name} loading="lazy" />
                            <a
                                href={file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="doc-action"
                            >
                                Open PDF
                            </a>
                        </div>
                    );
                }

                return (
                    <div key={i} className="document-download">
                        <span className="doc-name">{file.name}</span>
                        <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="doc-action"
                        >
                            Download
                        </a>
                    </div>
                );
            })}
        </div>
    );

    const renderFiles = () => {
        if (!orgPost.files?.length) return null;

        switch (orgPost.files[0].type) {
            case "image":
                return renderImages();
            case "video":
                return renderVideo(orgPost.files[0]);
            case "document":
                return renderDocuments();
            default:
                return null;
        }
    };

    const deletePost = async () => {
        const confirmed = window.confirm("Delete this post?");
        if (!confirmed) return;

        try {
            setloadDelete(true);

            const res = await api.delete(`/${orgPost.organization.name}/posts/${orgPost._id}`);
            toast.success(res.data.message)
        } catch (err) {
            console.error(err);
            alert("Something went wrong deleting post");
        } finally {
            setloadDelete(false);
        }
    };

    const handleBookmark = async (id, type) => {
        setPostInfo(false)
        try {
            const response = await api.post('/feeds/bookmarks', {
                post: id,
                type: type
            });


            if (response.data.success) {
                alert("Bookmarked!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    };

    const handelFollow = async (id) => {
        setProfileInfo(false)
        try {
            const response = await api.post(`/${orgPost.organization.name}/follow`, {
                orgId: orgPost.organization._id
            });


            if (response.data.success) {
                alert("Followed!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    }
    const handleReport = async (id, type) => {
        setPostInfo(false)
        try {
            const response = await api.post('/feeds/report', {
                post: id,
                type
            });
            if (response.data.success) {
                toast.success("post reported!");
            } else {
                toast(response.data.message);
            }

        } catch (error) {
            alert(error.response.data.message);
        } finally {
            // Optional: End loading state
        }
    }

    return (
        <div className='post'>
            <div className='org-post'>
                <div className="org-post-header">
                    <div className="org-post-org-info">
                        <div className="profile-details">
                            <img
                                src={
                                    orgPost.organization?.logo?.current
                                        ? orgPost.organization.logo.current.url
                                        : officeImg
                                } alt="user profile"
                                className="orgPost-profile-img"
                                onClick={() => navigate(`/${orgPost.organization.name}`)}
                            />
                            <div className="post-data-details">
                                <p
                                    className="post-profile-name"
                                    onClick={() => navigate(`/${orgPost.organization.name}`)}
                                >
                                    {orgPost?.organization?.name}

                                </p>
                                <div className="post-dates">
                                    <p>{moment(orgPost.createdAt).fromNow()}</p>
                                    <p className='post-audience'>{orgPost.audience}</p>
                                    <p className='post-label'>{orgPost.postLabel}</p>
                                </div>
                            </div>
                        </div>
                        <div className=""
                            onClick={toogleProfileInfo}
                        >
                            <FaEllipsisV />
                        </div>
                    </div>


                    <Link to={`/user/${orgPost.createdBy?._id}`}>
                        <div className="org-post-user">
                            <div className="org-post-userimg">
                                <img src={orgPost.createdBy?.avatar ? orgPost.createdBy.avatar.url : UserImage} alt='' />
                            </div>
                            <div className="org-post-username">
                                <h3 className=''>{orgPost.createdBy?.firstname} {orgPost.createdBy?.lastname}</h3>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={profileInfo ? "profile-info" : "closed-info"}>
                    <div className="post-button-wrapper">
                        <FaMarker />
                        <button className="post-info-btn" onClick={() => handelFollow(orgPost.createdBy._id)}>Follow</button>
                    </div>
                    <FaTimes onClick={() => setProfileInfo(false)} />
                </div>
                <div className={postInfo ? "post-info" : "closed-info"}>
                    <FaTimes onClick={() => setPostInfo(false)} />
                    <div className="post-button-wrapper">
                        <FaSave />
                        <button className="post-info-btn" onClick={() => handleBookmark(orgPost._id, "organization")}>Bookmark</button>
                    </div>
                    <div className="post-button-wrapper">
                        <FaShare />
                        <button className="post-info-btn">Share to</button>
                    </div>
                    <div className="share-options">
                        <p className="share-option">My Profile</p>
                        <p className="share-option" onClick={() => navigate(`/${orgPost.organization.name}/posts/${orgPost._id}/share`, { state: { post: orgPost } })}>Organization</p>
                        <p className="share-option">see more...</p>
                    </div>
                    {
                        userId && orgPost?.createdBy?._id === userId &&
                        <button
                            className="post-info-btn"
                            onClick={() => navigate(`/${orgPost.organization.name}/posts/${orgPost._id}/edit`, { state: { post: orgPost } })}>
                            <FaPen />Edit</button>
                    }
                    {
                        userId && userId === orgPost?.createdBy?._id &&
                        <div className="post-button-wrapper">
                            <FaTrash />
                            <button className="post-info-btn" onClick={deletePost}>Delete</button>
                        </div>
                    }
                    <div className="post-button-wrapper">
                        <FaFlag />
                        <button className="post-info-btn" onClick={() => handleReport(orgPost._id, "organization")}>Report</button>
                    </div>
                </div>
                <div className="post-body">
                    {
                        orgPost.postText &&
                        <Linkify options={linkifyOptions}>
                            <div className="text" onClick={() => navigate(`/${orgPost.organization.name}/posts/${orgPost._id}`, { state: { post: orgPost } })}
                            >
                                {orgPost?.postText?.length > 200
                                ? orgPost.postText.substring(0, 200) + '...'
                                : orgPost.postText}
                            </div>
                        </Linkify>
                    }

                    {orgPost.files?.length > 0 &&
                        <div className="postcard-images">
                            {renderFiles()}
                        </div>
                    }
                </div>
                <div className="post-footer">
                    <div className="post-footer-icon"
                        onClick={() => likePost(orgPost._id)}
                    >
                        {liked ? <FaThumbsUp /> : <FaRegThumbsUp />}
                        <p>{likesCount}</p>
                    </div>
                    <div className="post-footer-icon"
                        onClick={() => navigate(`/${orgPost.organization.name}/posts/${orgPost._id}`, { state: { post: orgPost } })}
                    >
                        <FaComment />
                        <p>{orgPost.commentsCount}</p>
                    </div>
                    <div className="post-footer-icon"
                        onClick={tooglePostInfo}
                    >
                        <FaEllipsisH />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrgPostCard